import { Block, Flex } from '@aloft/toolkit-sui';

import { useBreakpoints } from '../../../../hooks/useBreakpoints.ts';

export function FormRow({ children }: { children: [React.ReactNode, React.ReactNode] }) {
  const { isMobileAndBelow } = useBreakpoints();
  return (
    <Flex gap={4} flexDirection={isMobileAndBelow ? 'column' : undefined}>
      <Block flex={1}>{children[0]}</Block>
      <Block flex={1}>{children[1]}</Block>
    </Flex>
  );
}
